import { createListenerMiddleware, } from '@reduxjs/toolkit'
import { languageChanged, titleUpdated } from '../../App/app';
import i18n from '../../i18n/i18n';
import { RootState } from '../store';

const listenerMiddlewareMeta = createListenerMiddleware();

const suffix = 'Hella Gutmann';
const delimiter = ' - ';

listenerMiddlewareMeta.startListening( {
  actionCreator: titleUpdated,
  effect: async( action, listenerApi ) => {

    if( action.payload ) {
      document.title = `${ action.payload }${ delimiter }${ suffix }`;
    } else {
      document.title = `${ suffix }`;
    }
  }
} )

listenerMiddlewareMeta.startListening( {
  actionCreator: languageChanged,
  effect: async( action, listenerApi ) => {

    const description = document.head.querySelector( 'meta[name=description]' );
    if( description ) description.setAttribute( 'content', i18n.t(
      'manage-your-user-profile-with-hella-gutmann-accounts'
    ) );

  }
} )

export default listenerMiddlewareMeta;
